import { memo } from "react";
import { HorizontalIcon, VerticalIcon } from "@/icons/mind-map-directions";
import { HStack } from "@/shared/ui/Stack";
import { MenuButton } from "../MenuButton/MenuButton";

interface MindMapDirectionMenuContentProps {
    onDirectionButtonClick: (direction: string) => void;
}

export const MindMapDirectionMenuContent = memo(function MindMapDirectionMenuContent({
    onDirectionButtonClick,
}: MindMapDirectionMenuContentProps) {
    return (
        <HStack gap={4}>
            <MenuButton onClick={() => onDirectionButtonClick("horizontal")}>
                <HorizontalIcon />
            </MenuButton>

            <MenuButton onClick={() => onDirectionButtonClick("vertical")}>
                <VerticalIcon />
            </MenuButton>
        </HStack>
    );
});
